import React from 'react';
import './DocumentsList.css';
import { ReactComponent as DocumentIcon } from '../../assets/icons/document.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/export.svg';

interface DocumentsListProps {
  documents: Array<{
    type: string;
    uploaded: boolean;
  }>;
}

const DocumentsList: React.FC<DocumentsListProps> = ({ documents }) => {
  return (
    <div className="documents-list">
      {/* <h2>Documents</h2> */}
      <div className="documents-grid">
        {documents.map((doc, index) => (
          <div key={index} className="document-item">
            <div className="document-info">
              <DocumentIcon />
              <span>{doc.type}</span>
            </div>
            <button
              className="download-button"
              onClick={() => console.log(`Downloading ${doc.type}`)}
            >
              <DownloadIcon />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentsList;